import PropTypes from 'prop-types';
import React, { forwardRef, useEffect, useState } from 'react';
import SearchAreaControl from './SearchAreaControl';

// renderMap does not consider progressive disclosure flipper internally
const RenderMap = forwardRef(
  (
    {
      currentQuery,
      handleSearchArea,
      isSearching,
      mapboxGlContainer,
      map,
      mobile,
      mobileMapUpdateEnabled,
      results,
      searchAreaButtonEnabled,
      selectMobileMapPin,
      shouldRenderSearchArea,
      smallDesktop,
      zoomMessageDivID,
    },
    ref,
  ) => {
    const [skipLinkHref, setSkipLinkHref] = useState('#footerNav');

    useEffect(() => {
      if (map) {
        map.resize();
      }
    }, [map]);

    useEffect(() => {
      // set the link location to the feedback button if it's there
      const feedbackButtonPresent = !!document.getElementById('mdFormButton');
      if (feedbackButtonPresent) {
        setSkipLinkHref('#mdFormButton');
      }
    }, []);

    return (
      <>
        {!isSearching && (results?.length || 0) > 0 ? (
          <h2 data-testid="map-of-results-sr" className="sr-only">
            Map of Results
          </h2>
        ) : null}
        <div id={zoomMessageDivID} aria-live="polite" className="sr-only" />
        <p
          className="sr-only"
          id="map-instructions"
          data-testid="map-instructions"
          aria-live="polite"
        />

        {/* Positioning context for #skip-map-link's absolute offsets (#23051). */}
        <div className="skip-map-and-canvas-wrapper">
          <va-link
            id="skip-map-link"
            className="skip-map-link"
            href={skipLinkHref}
            text="Skip map"
          />

          <div
            id={mapboxGlContainer}
            data-testid={mapboxGlContainer}
            ref={ref}
            className={
              mobile
                ? 'mobile'
                : `${smallDesktop ? 'desktop' : 'tablet'}-map-container`
            }
          >
            {shouldRenderSearchArea && (
              <SearchAreaControl
                handleSearchArea={handleSearchArea}
                isMobile={mobile}
                isEnabled={searchAreaButtonEnabled}
                mobileMapUpdateEnabled={mobileMapUpdateEnabled}
                query={currentQuery}
                selectMobileMapPin={selectMobileMapPin}
              />
            )}
          </div>
        </div>
      </>
    );
  },
);

RenderMap.propTypes = {
  currentQuery: PropTypes.object,
  handleSearchArea: PropTypes.func,
  isSearching: PropTypes.bool,
  map: PropTypes.object,
  mapboxGlContainer: PropTypes.string,
  mobile: PropTypes.bool,
  mobileMapUpdateEnabled: PropTypes.bool,
  results: PropTypes.array,
  searchAreaButtonEnabled: PropTypes.bool,
  selectMobileMapPin: PropTypes.func,
  shouldRenderSearchArea: PropTypes.bool,
  smallDesktop: PropTypes.bool,
  zoomMessageDivID: PropTypes.string,
};

export default RenderMap;
